var i18n = {
  SELECT_PLACEHOLDER: 'Select…',
  INPUT_SHOW_PASSWORD_BUTTON_HINT: 'Show password',
  INPUT_HIDE_PASSWORD_BUTTON_HINT: 'Hide password',
  FORM_MESSAGE_INVALID_COLOR: 'Invalid color format — valid example: "#ff45da"',
  FORM_MESSAGE_INVALID_DATE: 'Invalid date format (yyyy-mm-dd)',
  FORM_MESSAGE_INVALID_DATETIME: 'Invalid date and time format',
  FORM_MESSAGE_INVALID_MONTH: 'Invalid month format (yyyy-mm)',
  FORM_MESSAGE_INVALID_TIME: 'Invalid time format (hh:mm:ss)',
  FORM_MESSAGE_INVALID_NUMBER: 'Invalid number',
  FORM_MESSAGE_INVALID_URL: 'Invalid URL',
  FORM_MESSAGE_INVALID_TEL: 'Invalid telephone number',
  FORM_MESSAGE_INVALID_EMAIL: 'Invalid email',
  FORM_MESSAGE_PASSWORD_TOO_SHORT: 'Need at least {min} characters',
  FORM_MESSAGE_REQUIRED: 'This field is required',
  FORM_MESSAGE_INVALID_GENERAL: 'Invalid format'
};
export default i18n;